import {
  RecommendationPriority,
  RecommendationStatus,
  RecommendationType
} from './recommendation.model';
import { TenantSite } from './tenant.model';
import { AlertLevel } from './user.model';

export enum WebhookConditionOperator {
  Or = 'or',
  And = 'and',
  Equals = '=',
  Changed = 'changed'
}

export enum WebhookWorkflowChangeType {
  StatusChange = 'status',
  ObjectAdded = 'object added',
  CostAvoidanceChange = 'costavoidance'
}

export enum WebhookWorkflowObjectAddedType {
  Comment = 'comments',
  Alert = 'alerts',
  Attachment = 'files'
}

export interface Webhook {
  id: string;
  name: string;
  description: string;
  enabled: boolean;
  sites: TenantSite[] | null; // null = 'all my sites'
  entityType: WebhookEntityType;
}

export interface UserWebhook extends Webhook {
  notificationType: {
    email: boolean;
    sms: boolean;
  };
  level?: AlertLevel[] | null;
  priority?: RecommendationPriority[] | null; // null = 'any'
  type?: RecommendationType[] | null; // null = 'any',
  workflowChange?: WebhookWorkflowChange;
}

export interface SystemWebhook extends Webhook {
  url: string;
  headers: WebhookHeader[];
  events: WebhookEventType[];
  custom: boolean;
}

export interface WebhookWorkflowChange {
  type: WebhookWorkflowChangeType;
  value: RecommendationStatus[] | WebhookWorkflowObjectAddedType[] | null;
}

export interface WebhookHeader {
  key: string;
  value: string;
}

export interface ClientTokens {
  clientId: string;
  clientSecret: string;
}

export enum WebhookType {
  User = 'user'
}

export enum WebhookEntityType {
  Recommendation = 'recommendation',
  Alert = 'alert',
  EFPIntegrations = 'efp integration'
}

export enum WebhookEventType {
  Create = 'create',
  Update = 'update'
}

export interface ResponseWebhook {
  id: string;
  name: string; // 'ah test webhook',
  description: string; // 'Testing webhook implementation for recommendations',
  entitytype: WebhookEntityType; // 'recommendation',
  isactive: boolean; // true
  events: WebhookEventType[]; // ['create', 'update'],
  actions: {
    type: string; // email
    [key: string]: string; // 'emailaddress': 'aheinric@advancedtech.com'
  }[];
  condition: ResponseWebhookCondition;
  custom: boolean;
  type: WebhookType;
}

export interface ResponseWebhookCondition {
  operator: WebhookConditionOperator;
  property?: string;
  value?: string;
  conditions?: ResponseWebhookCondition[];
}

export interface ResponseClientTokens {
  client_id: string;
  client_secret: string;
}
